/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react'
import { withStyles } from '@material-ui/core'
import styles from './styles'
import { CoreTextField, CoreButton } from 'src/components/core'
import { useDispatch } from 'react-redux'
import { messageBoxHideAction } from 'src/reducers/message-box/action'
import { shopPatchAction } from 'src/reducers/shop/action'
import { track } from '@amplitude/analytics-browser'

const WorkspaceEdit = props => {
  const { classes, currentWorkspaceName, currentWorkspaceId } = props
  const dispatch = useDispatch()
  const [workspaceName, setWorkspaceName] = useState(currentWorkspaceName || '')

  const handleEditWorkspace = () => {
    if (workspaceName && workspaceName.trim() !== '') {
      const nextWorkspaceName = workspaceName.trim()
      dispatch(
        shopPatchAction(
          {
            id: currentWorkspaceId,
            name: nextWorkspaceName,
          },
          () => {
            track('workspace_name_edit', {
              shop_id: currentWorkspaceId || null,
              old_workspace_name: currentWorkspaceName || null,
              new_workspace_name: nextWorkspaceName,
            })
            window.location.reload()
          }
        )
      )
      dispatch(messageBoxHideAction())
    }
  }

  const handleCancel = () => {
    dispatch(messageBoxHideAction())
  }

  return (
    <div className={classes.namingModalContent}>
      <CoreTextField
        defaultValue={workspaceName}
        fullWidth
        label="What's the new name of your workspace?"
        onChange={e => setWorkspaceName(e.target.value)}
        inputProps={{ maxLength: 36 }}
        autoFocus
        onKeyPress={e => {
          if (
            e.key === 'Enter' &&
            workspaceName &&
            workspaceName.trim() !== ''
          ) {
            handleEditWorkspace()
          }
        }}
      />
      <div className={classes.buttonContainer}>
        <CoreButton onClick={handleCancel} variant="text" color="secondary">
          Cancel
        </CoreButton>
        <CoreButton
          onClick={handleEditWorkspace}
          color="primary"
          disabled={
            !workspaceName ||
            workspaceName.trim() === '' ||
            workspaceName.length < 2
          }
        >
          Save
        </CoreButton>
      </div>
    </div>
  )
}

export default withStyles(styles)(WorkspaceEdit)
